import { SwapDto, SwapNft } from '../types/dto/Swap.dto';
import { getMetadataImage } from './nft';
import { NFTMetadata, OSNFTMetadata } from '../types/dto/UserNFTs.dto';
import { INFT } from '../types/nft';
import { SwapStatus } from '../types/enums';
import { formatEther } from 'ethers/lib/utils';
import { ISwap } from '../types/swap';
import { getCustomMetadataName } from '../hooks/apollo/loadNFTsWithMetadata';
import { TransactionList } from '../services/Etherscan/getTransactionList';

export type Metadatas = {
  [address: string]: NFTMetadata;
};

export type OSMetadatas = {
  [address: string]: OSNFTMetadata;
};

export const formatToISwap = (
  swap: SwapDto,
  metadatas: Metadatas,
  OSmetadatas: OSMetadatas,
  account: string | null | undefined,
  transaction?: TransactionList,
  floorPrice?: { [address: string]: number },
): ISwap => {
  let nfts: {
    userNFTs: INFT[];
    offeredNFTs: INFT[];
    isAnswerable: boolean;
    userEth: string;
    offeredEth: string;
    estimatedValue?: number;
  };

  if ((account && account.toUpperCase()) === swap.from.id.toUpperCase()) {
    nfts = {
      userNFTs: mapSwapNftToINFT(swap.initiatorNfts, metadatas, OSmetadatas),
      userEth: swap.initiatorEther ? formatEther(swap.initiatorEther) : '',
      offeredNFTs: mapSwapNftToINFT(swap.secondUserNfts, metadatas, OSmetadatas),
      offeredEth: swap.initiatorEther ? formatEther(swap.secondUserEther) : '',
      isAnswerable: swap.status === SwapStatus.INITIATED,
    };
  } else {
    nfts = {
      userNFTs: mapSwapNftToINFT(swap.secondUserNfts, metadatas, OSmetadatas),
      userEth: swap.initiatorEther ? formatEther(swap.secondUserEther) : '',
      offeredNFTs: mapSwapNftToINFT(swap.initiatorNfts, metadatas, OSmetadatas),
      offeredEth: swap.initiatorEther ? formatEther(swap.initiatorEther) : '',
      isAnswerable: swap.status === SwapStatus.PROPOSED,
    };
  }

  return {
    ...nfts,
    id: swap.id,
    swapId: swap.swapId,
    contract: swap.contract,
    fromUser: swap.from.id,
    toUser: swap.to.id,
    status: swap.status,
    timeStamp: new Date(parseInt(swap.createdAt) * 1000).toISOString(),
    swapDate: transaction?.timeStamp ? new Date(transaction?.timeStamp * 1000).toDateString() : '',
    transactionHash: transaction?.hash,
    estimatedValue: estimatedValue(
      [...swap.initiatorNfts, ...swap.secondUserNfts],
      formatEther(swap.initiatorEther),
      formatEther(swap.secondUserEther),
      floorPrice,
    ),
  };
};

const mapSwapNftToINFT = (swapNfts: SwapNft[], metadatas: Metadatas, OSmetadatas: OSMetadatas): INFT[] => {
  return swapNfts.map((nft) => {
    // geting the OS metadata object for the respective token
    let nftOSMetadata: OSNFTMetadata | undefined;
    Object.keys(OSmetadatas).forEach((e) => {
      if (nft.id.startsWith(e)) nftOSMetadata = OSmetadatas[e];
    });

    return {
      id: nft.id,
      name: nftOSMetadata?.name || metadatas[nft.id]?.name || getCustomMetadataName(nft.token.id),
      contractAddress: nft.token.id,
      tokenId: nft.identifier,
      description: nftOSMetadata?.description || metadatas[nft.id]?.description,
      imgUrl: nftOSMetadata?.image_url || getMetadataImage(metadatas[nft.id]),
      verified: nftOSMetadata?.verified || false,
      openseaUrl: nftOSMetadata?.permalink || '',
      amount: nft.amount,
    };
  });
};

const estimatedValue = (
  nfts: SwapNft[],
  initiatorEther: string,
  secondUserEther: string,
  floorPrice?: { [address: string]: number },
): string => {
  let totalValue = 0.0;
  if (!floorPrice) {
    return NaN.toString();
  }
  nfts.forEach((e) => {
    Object.keys(floorPrice).forEach((k) => {
      if (e.id.startsWith(k)) {
        totalValue += floorPrice[k]; //['floorPrice'];
      }
    });
  });
  totalValue += parseFloat(initiatorEther);
  totalValue += parseFloat(secondUserEther);

  if (totalValue.toString().indexOf('.') > 0) {
    if (totalValue >= 0.01) {
      return totalValue.toString().slice(0, totalValue.toString().indexOf('.') + 3) + ' Ξ';
    } else {
      return totalValue.toString() + ' Ξ';
    }
  } else {
    return '';
  }
};
